export default [
    {
        "error_id": "FD-01",
        "profiles": [
            "100yr (1%)",
            "FW",
            "10yr (10%)",
            "50yr (2%)",
            "500yr (0.2%)"
        ],
        "data": [
            {
                "cross_section": "8551",
                "profile": "500yr (0.2%)",
                "val": 9420,
                "is_increase": true
            },
            {
                "cross_section": "8551",
                "profile": "50yr (2%)",
                "val": 5240,
                "is_increase": true
            },
            {
                "cross_section": "8551",
                "profile": "10yr (10%)",
                "val": 3180,
                "is_increase": false
            },
            {
                "cross_section": "8551",
                "profile": "FW",
                "val": 6320,
                "is_increase": true
            },
            {
                "cross_section": "8551",
                "profile": "100yr (1%)",
                "val": 6320,
                "is_increase": true
            },
            {
                "cross_section": "9714.5",
                "profile": "500yr (0.2%)",
                "val": 9190,
                "is_increase": true
            },
            {
                "cross_section": "9714.5",
                "profile": "50yr (2%)",
                "val": 5100,
                "is_increase": true
            },
            {
                "cross_section": "9714.5",
                "profile": "10yr (10%)",
                "val": 3090,
                "is_increase": false
            },
            {
                "cross_section": "9714.5",
                "profile": "FW",
                "val": 6160,
                "is_increase": true
            },
            {
                "cross_section": "9714.5",
                "profile": "100yr (1%)",
                "val": 6160,
                "is_increase": true
            },
            {
                "cross_section": "12339",
                "profile": "500yr (0.2%)",
                "val": 8840,
                "is_increase": true
            },
            {
                "cross_section": "12339",
                "profile": "50yr (2%)",
                "val": 4900,
                "is_increase": true
            },
            {
                "cross_section": "12339",
                "profile": "10yr (10%)",
                "val": 2960,
                "is_increase": false
            },
            {
                "cross_section": "12339",
                "profile": "FW",
                "val": 5910,
                "is_increase": true
            },
            {
                "cross_section": "12339",
                "profile": "100yr (1%)",
                "val": 5910,
                "is_increase": true
            },
            {
                "cross_section": "14598",
                "profile": "500yr (0.2%)",
                "val": 8450,
                "is_increase": true
            },
            {
                "cross_section": "14598",
                "profile": "50yr (2%)",
                "val": 4670,
                "is_increase": true
            },
            {
                "cross_section": "14598",
                "profile": "10yr (10%)",
                "val": 2820,
                "is_increase": false
            },
            {
                "cross_section": "14598",
                "profile": "FW",
                "val": 5650,
                "is_increase": true
            },
            {
                "cross_section": "14598",
                "profile": "100yr (1%)",
                "val": 5650,
                "is_increase": true
            },
            {
                "cross_section": "16305",
                "profile": "500yr (0.2%)",
                "val": 8230,
                "is_increase": true
            },
            {
                "cross_section": "16305",
                "profile": "50yr (2%)",
                "val": 4550,
                "is_increase": true
            },
            {
                "cross_section": "16305",
                "profile": "10yr (10%)",
                "val": 2740,
                "is_increase": false
            },
            {
                "cross_section": "16305",
                "profile": "FW",
                "val": 5500,
                "is_increase": true
            },
            {
                "cross_section": "16305",
                "profile": "100yr (1%)",
                "val": 5500,
                "is_increase": true
            },
            {
                "cross_section": "18856",
                "profile": "500yr (0.2%)",
                "val": 7660,
                "is_increase": true
            },
            {
                "cross_section": "18856",
                "profile": "50yr (2%)",
                "val": 4210,
                "is_increase": true
            },
            {
                "cross_section": "18856",
                "profile": "10yr (10%)",
                "val": 2530,
                "is_increase": false
            },
            {
                "cross_section": "18856",
                "profile": "FW",
                "val": 5100,
                "is_increase": true
            },
            {
                "cross_section": "18856",
                "profile": "100yr (1%)",
                "val": 5100,
                "is_increase": true
            }
        ]
    }
]